import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.isDesktop, action) =>
  action.type === types.SET_IS_DESKTOP ? Boolean(action.payload) : state
